import { Outlet } from 'react-router-dom'

const VoucherUsage = () => <Outlet />

export default VoucherUsage
